/* unplugin-vue-components disabled */import __unplugin_components_0 from '/app/src/components/core/alarmLogs/reportList.vue';
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"n20-container",attrs:{"data-cy":"view-alarm-logs-report-list","fluid":""}},[_c(__unplugin_components_0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }